import documents from './documents'
import adminUserAttributes from './adminUserAttributes'
import { activeOrganizationResolver } from './deprecated/activeOrganization'
import { profileResolver } from './deprecated/profile'
import { rolesResolver } from './deprecated/roles'
import { accessoryDrawerStateResolver } from './deprecated/accessoryDrawerState'

import type { QueryResolvers } from '../../../../generated/graphql'

const Query: QueryResolvers = {
    ...documents,
    adminUserAttributes,
    activeOrganization: activeOrganizationResolver,
    profile: profileResolver,
    roles: rolesResolver,
    accessoryDrawerState: accessoryDrawerStateResolver,
}

export default Query
